<template>
    <div class="cbm-overlay" @click.self="close">
        <div class="cbm-box">
            <!-- the close button lives in the board header; the page posts {type:'admin', subtype:'close_modal'} -->
            <iframe ref="frame" :src="url" class="cbm-frame" frameborder="0" allow="clipboard-write"></iframe>
        </div>
    </div>
</template>

<script>
/**
 * Collab Board (Quadro Colaborativo) opened over the Unity scene on a `unity_message` / `collab_board` command.
 * The page inside the iframe is served by the API (/collab-board/{template}); it asks this window for the
 * current user the same way the avia chat does ({message_type:'avia', data:{subtype:'user'}}) and this modal
 * answers only to its own iframe.
 */
import { mapGetters } from "vuex";
import { focusUnity } from "@/helper";

export default {
    name: "CollabBoardModal",
    props: ["url"],
    computed: {
        ...mapGetters(["id", "token", "checkMobile"]),
    },
    methods: {
        onMessage(event) {
            const frame = this.$refs.frame;
            if (!frame || event.source !== frame.contentWindow) return;
            const data = event.data || {};
            if (data.message_type === "avia" && data.data && data.data.subtype === "user") {
                frame.contentWindow.postMessage({
                    message_type: "external",
                    type: "ai_message",
                    subtype: "user_id",
                    user_id: this.id,
                    token: this.token,
                    design: this.$app ? this.$app.design : null,
                    language: this.$i18n ? this.$i18n.locale : "pt-br",
                }, "*");
                return;
            }
            if (data.type === "admin" && data.subtype === "close_modal") {
                this.close();
            }
        },
        close() {
            this.$emit("close");
            focusUnity(this.checkMobile);
        },
    },
    mounted() {
        window.addEventListener("message", this.onMessage);
    },
    beforeDestroy() {
        window.removeEventListener("message", this.onMessage);
    },
};
</script>

<style scoped>
.cbm-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, .55);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}
.cbm-box {
    position: relative;
    width: min(1100px, 100%);
    height: min(860px, 100%);
    background: #eef0f3;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, .35);
}
.cbm-frame { width: 100%; height: 100%; display: block; border: 0; }
@media (max-width: 640px) {
    .cbm-overlay { padding: 0; }
    .cbm-box { border-radius: 0; width: 100%; height: 100%; }
}
</style>
